import { InlineEditingProvider } from '@/providers/InlineEditingProvider/InlineEditingProvider';

import type { VariantComponent } from './types';

export const Variant1: VariantComponent = (args) => <InlineEditingProvider {...args} isInlineEditing />;
